<template>
  <div class="image-question-page">
    <Header class="image-question-legacy-header"></Header>
    <header class="image-question-header" v-if="gameState !== 'ended'">
      <button class="image-question-back" type="button" :aria-label="$t('Back')" @click="$router.go(-1)">
        <img src="../../static/images/livequiz/back.png" alt="">
      </button>
    </header>

    <section class="image-question-intro" v-if="gameState === 'intro'">
      <img class="image-question-page-title" src="../../static/images/guess_word/guess_words_title.png" :alt="$t('GuessWords')">
      <div class="image-question-intro-panel">
        <img class="image-question-intro-panel-bg" src="../../static/images/ai_training/ai_training_bg.png" alt="">
        <div class="image-question-intro-content">
          <p>{{ $t('QuizCenterGuessWordsC') }}</p>
          <img class="image-question-intro-hero" src="../../static/images/guess_word/guess_word_photo.png" alt="">
          <button class="image-question-start" type="button" @click="beginGame">{{ $t('StartNow') }}</button>
        </div>
      </div>
    </section>

    <section class="image-question-battle" v-if="gameState === 'playing'">
      <img class="image-question-page-title image-question-battle-title" src="../../static/images/guess_word/guess_words_title.png" :alt="$t('GuessWords')">

      <div v-if="countdownVisible" class="image-question-countdown">
        <img class="image-question-countdown-number" :key="countdownNumber" :src="'static/images/livequiz/ready/' + countdownNumber + '.png'" :alt="countdownNumber">
      </div>

      <div class="image-question-card" v-if="!countdownVisible && currentQuestion">
        <div class="image-question-timer" :style="{ '--timer-progress': (timeTotal ? Math.max(0, (timeTotal - timeLeft) / timeTotal * 360) : 0) + 'deg' }">
          <strong>{{ timeLeft }}</strong>
        </div>
        <div class="image-question-number">{{ $t('Question') }} {{ draw_num + 1 }}</div>
        <img class="image-question-photo" :src="currentQuestion.path" alt="">
        <input
          v-model="input"
          class="image-question-input"
          type="text"
          autocomplete="off"
          :placeholder="$t('image_input_placeholder')"
          @keyup.enter="answerClick(input)"
        >
        <button class="image-question-next" type="button" @click="answerClick(input)">
          <img src="../../static/images/guess_word/next_btn.png" alt="">
          <span>{{ $t('next') }}</span>
          <img class="image-question-next-arrow" src="../../static/images/guess_word/next_arrow.png" alt="">
        </button>
      </div>
    </section>

    <!-- 单人结算：保留统一提交答案的原有逻辑，只替换展示层。 -->
    <div class="image-question-result-popup" v-if="gameState === 'ended'">
      <div class="image-question-result-mask"></div>
      <section class="image-question-result-dialog" role="dialog" aria-modal="true" :aria-label="$t('SingleQuizOverTitle')">
        <div class="image-question-result-header">
          <img src="../../static/images/win_lose/pop_up_header.png" alt="">
          <h2>{{ $t('SingleQuizOverTitle') }}</h2>
        </div>
        <div class="image-question-result-card">
          <img class="image-question-result-card-bg" src="../../static/images/win_lose/pop_up_bg.png" alt="">
          <div class="image-question-result-content">
            <p class="image-question-result-message">
              {{ $t('SingleQuizOverMessagePrefix') }} <strong>{{ $t('SingleQuizOverMessageHighlight') }}</strong>
            </p>
            <img class="image-question-result-hero" src="../../static/images/win_lose/quiz_over.png" alt="">
            <div class="image-question-result-scores">
              <img src="../../static/images/win_lose/score_bg.png" alt="">
              <div class="image-question-result-score">
                <span>{{ $t('YourScore') }}</span>
                <div class="image-question-result-score-number">
                  <img src="../../static/images/home/pts.png" alt="">
                  <strong>{{ score }}</strong>
                </div>
              </div>
            </div>
            <div class="image-question-result-actions">
              <button type="button" @click="getClose">
                <img src="../../static/images/win_lose/back.png" alt="">
                <span>{{ $t('Back') }}</span>
              </button>
              <button type="button" @click="beginGame">
                <img src="../../static/images/win_lose/play_again.png" alt="">
                <span>{{ $t('PlayAgain') }}</span>
              </button>
            </div>
          </div>
        </div>
        <button class="image-question-result-close" type="button" :aria-label="$t('Back')" @click="getClose">
          <img src="../../static/images/buy_more/close.png" alt="">
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import Header from '../components/HeaderQuiz'
import '../../static/js/howler.min.js'

export default {
  components: { Header },
  data() {
    return {
      draw_num: 0,
      answerT: [],
      question: {},
      answerReson: {},
      timeLeft: 15,
      timeTotal: 15,
      answerTimeTotal: 15,
      timerInterval: null,
      countdownInterval: null,
      countdownVisible: false,
      countdownNumber: 3,
      questionsLoaded: false,
      gameState: 'intro',
      score: 0,
      input: '',
      sounds: {
        ready: null
      }
    }
  },
  computed: {
    currentQuestion() {
      const questions = (this.question || {}).question || [];
      return questions[this.draw_num] || null;
    }
  },
  created() {
    this.initHowler();
  },
  beforeDestroy() {
    this.clearTimers();
    if (this.sounds.ready) {
      this.sounds.ready.unload();
    }
  },
  methods: {
    initHowler() {
      Howler.autoUnlock = true;
      Howler.mobileAutoEnable = true;
      this.sounds.ready = new Howl({
        src: ['../../static/music/countdown.mp3'],
        volume: 1.0,
        preload: true
      });
    },
    playReady() {
      this.sounds.ready.play();
    },
    beginGame() {
      this.clearTimers();
      this.draw_num = 0;
      this.answerT = [];
      this.question = {};
      this.input = '';
      this.score = 0;
      this.timeLeft = this.answerTimeTotal;
      this.questionsLoaded = false;
      this.gameState = 'playing';
      this.getHome();
      this.startCountDown();
    },
    clearTimers() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    startCountDown() {
      this.countdownVisible = true;
      this.countdownNumber = 3;
      this.playReady();
      this.countdownInterval = setInterval(() => {
        this.countdownNumber -= 1;
        if (this.countdownNumber <= 0) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
          this.countdownVisible = false;
          this.startTimerWhenReady();
        }
      }, 1000);
    },
    startTimerWhenReady() {
      if (this.gameState === 'playing' && !this.countdownVisible && this.questionsLoaded && this.currentQuestion) {
        this.startTimer();
      }
    },
    startTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.timerInterval = setInterval(() => {
        this.timeLeft -= 1;
        if (this.timeLeft <= 0) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
          this.advanceQuestion();
        }
      }, 1000);
    },
    answerClick(item) {
      if (!item || !this.currentQuestion) return;
      this.answerT.push({
        id: this.currentQuestion.id,
        correct_answer: item
      });
      this.advanceQuestion();
    },
    advanceQuestion() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      this.input = '';
      this.draw_num += 1;
      const questions = (this.question || {}).question || [];
      if (this.draw_num >= questions.length) {
        this.getAnswer();
        return;
      }
      this.timeLeft = this.answerTimeTotal;
      this.startTimer();
    },
    getAnswer() {
      const data = {
        question_id: this.question.question_id,
        answer: this.answerT
      };
      this.$api.post('/api/question/sub_answer', data, r => {
        this.$parent.returnCode(r, () => {
          this.$parent.loadModal(false);
          this.answerReson = r.data;
          this.score = r.data.score;
          this.gameState = 'ended';
          this.answerT = [];
        });
      });
    },
    getHome() {
      const data = {
        question_type: this.$route.query.question_type
      };
      this.$api.post('/api/question/get_question', data, r => {
        this.$parent.returnCode(r, () => {
          this.$parent.loadModal(false);
          this.question = r.data || {};
          this.questionsLoaded = Array.isArray(this.question.question) && this.question.question.length > 0;
          this.startTimerWhenReady();
        });
      });
    },
    getClose() {
      this.$router.push({ path: '/quizCenter' });
    }
  }
}
</script>

<style scoped>
.image-question-page { position:relative; min-height:100vh; box-sizing:border-box; isolation:isolate; padding:46px 28px 96px; overflow-x:hidden; color:#fff; background:#06021d url('../../static/images/livequiz/main_bg.jpg') center top/100% 100% no-repeat; font-family:Arial,Atom-sans,sans-serif; }
.image-question-page::before { position:absolute; z-index:0; inset:0; content:''; background:rgba(7,0,26,.2); pointer-events:none; }
.image-question-legacy-header { display:none; }
.image-question-header { position:absolute; z-index:20; top:46px; right:0; left:0; width:calc(100% - 56px); max-width:650px; margin:0 auto; }
.image-question-back { display:flex; width:72px; height:72px; align-items:center; justify-content:center; padding:0; border:0; background:transparent; cursor:pointer; }
.image-question-back img { display:block; width:100%; height:100%; object-fit:contain; }

.image-question-intro,.image-question-battle { position:relative; z-index:1; width:100%; max-width:650px; margin:0 auto; }
.image-question-page-title { display:block; width:min(78%,520px); margin:0 auto 58px; mix-blend-mode:screen; }
.image-question-intro-panel { position:relative; width:100%; aspect-ratio:1046 / 1420; overflow:hidden; }
.image-question-intro-panel-bg { position:absolute; inset:0; display:block; width:100%; height:100%; }
.image-question-intro-content { position:absolute; inset:0; display:flex; box-sizing:border-box; flex-direction:column; align-items:center; padding:12% 10% 9%; text-align:center; }
.image-question-intro-content > p { width:90%; margin:4% 0 0; color:#fff; font-size:clamp(17px,4.8vw,32px); font-weight:500; line-height:1.18; text-shadow:0 3px 7px rgba(18,0,35,.74); }
.image-question-intro-hero { display:block; width:108%; max-width:none; margin:18% 0 5%; object-fit:contain; }
.image-question-start { display:flex; width:76%; min-height:0; aspect-ratio:754 / 167; align-items:center; justify-content:center; margin-top:8%; padding:0; border:0; color:#fff; background:transparent url('../../static/images/livequiz/btn_bg.png') center/100% 100% no-repeat; cursor:pointer; font:inherit; font-size:clamp(21px,6vw,39px); font-weight:900; line-height:1; text-shadow:0 3px 5px rgba(81,0,42,.65); }

.image-question-battle-title { margin-bottom:86px; }
.image-question-countdown { position:fixed; z-index:9999; inset:0; display:flex; align-items:center; justify-content:center; background:rgba(5,0,25,.28); pointer-events:none; }
.image-question-countdown-number { display:block; width:min(64vw,430px); height:min(48vh,430px); object-fit:contain; filter:drop-shadow(0 16px 35px rgba(255,84,180,.22)); animation:imageQuestionCountdown .8s cubic-bezier(.25,.46,.45,.94) both; }
.image-question-card { position:relative; display:flex; width:100%; min-height:820px; box-sizing:border-box; flex-direction:column; align-items:center; padding:17% 7.2% 11.5%; background:transparent url('../../static/images/livequiz/start/quiz_bg.png') center/100% 100% no-repeat; color:#171722; }
.image-question-timer { --timer-progress:0deg; position:absolute; z-index:2; top:-66px; left:50%; display:flex; width:148px; height:148px; align-items:center; justify-content:center; border-radius:50%; background:conic-gradient(#f3164c 0deg,#f3164c var(--timer-progress),#4378da var(--timer-progress),#4378da 360deg); box-shadow:0 4px 12px rgba(13,24,88,.28); transform:translateX(-50%); }
.image-question-timer::after { position:absolute; inset:8px; border-radius:50%; content:''; background:#f2f1f4; }
.image-question-timer strong { position:relative; z-index:1; display:flex; width:100%; height:100%; align-items:center; justify-content:center; margin:0; padding:0; color:#16151f; font-size:clamp(42px,13vw,78px); font-style:normal; font-weight:900; line-height:1; text-align:center; }
.image-question-number { display:flex; width:clamp(150px,40%,205px); aspect-ratio:267 / 56; align-items:center; justify-content:center; margin:0 auto 24px; color:#25202c; background:transparent url('../../static/images/livequiz/start/question_bg.png') center/contain no-repeat; font-size:clamp(16px,4.2vw,27px); line-height:1; text-align:center; }
.image-question-photo { display:block; width:100%; height:clamp(240px,58vw,410px); box-sizing:border-box; border:1px solid rgba(255,255,255,.08); border-radius:30px; object-fit:contain; background:#120b26; }
.image-question-input { display:block; width:100%; height:clamp(78px,20vw,132px); box-sizing:border-box; margin-top:7%; padding:0 7%; border:0; border-radius:999px; outline:0; color:#1b1830; background:#e9ebf8 url('../../static/images/guess_word/txt_ans.png') center/100% 100% no-repeat; font:inherit; font-size:clamp(17px,4.8vw,31px); font-weight:500; line-height:1.2; text-align:center; }
.image-question-input::placeholder { color:#8e99bb; opacity:1; }
.image-question-next { position:relative; display:flex; width:86%; min-height:0; aspect-ratio:754 / 167; align-items:center; justify-content:center; gap:2%; margin-top:6%; padding:0 10%; overflow:hidden; border:0; background:transparent; color:#fff; cursor:pointer; font:inherit; }
.image-question-next > img:first-child { position:absolute; inset:0; width:100%; height:100%; object-fit:fill; }
.image-question-next span,.image-question-next-arrow { position:relative; z-index:1; }
.image-question-next span { font-size:clamp(22px,6vw,40px); font-weight:600; line-height:1; }
.image-question-next-arrow { width:clamp(11px,3vw,22px); height:auto; object-fit:contain; }

.image-question-result-popup { position:fixed; z-index:140; inset:0; }
.image-question-result-mask { position:absolute; inset:0; }
.image-question-result-dialog { position:absolute; top:11.5vh; left:50%; width:min(calc(100% - 28px),750px); transform:translateX(-50%); }
.image-question-result-header { position:relative; z-index:2; }
.image-question-result-header > img { display:block; width:100%; }
.image-question-result-header h2 { position:absolute; top:68%; right:7%; left:7%; margin:0; transform:translateY(-50%); color:#fff; font-size:clamp(30px,9vw,64px); font-weight:900; line-height:1; letter-spacing:-.05em; text-align:center; text-shadow:0 3px 2px #942006,0 0 8px rgba(255,190,35,.85); -webkit-text-stroke:1px #9d2a06; text-transform:uppercase; white-space:nowrap; }
.image-question-result-card { position:relative; margin-top:-5.5%; }
.image-question-result-card-bg { display:block; width:100%; }
.image-question-result-content { position:absolute; inset:0; display:flex; box-sizing:border-box; flex-direction:column; align-items:center; padding:13% 7.5% 8%; }
.image-question-result-message { min-height:2.2em; margin:0; color:#fff; font-size:clamp(15px,4.1vw,30px); font-weight:500; line-height:1.12; text-align:center; }
.image-question-result-message strong { color:#ffde00; font-weight:800; }
.image-question-result-hero { display:block; width:100%; max-width:620px; min-height:0; flex:1 1 auto; margin:1% auto 0; object-fit:contain; transform:scale(1.15); transform-origin:center bottom; }
.image-question-result-scores { position:relative; display:flex; width:100%; min-height:0; align-items:center; justify-content:center; margin-top:1%; aspect-ratio:887 / 203; }
.image-question-result-scores > img { position:absolute; inset:0; width:100%; height:100%; object-fit:fill; }
.image-question-result-score { position:relative; z-index:1; display:flex; min-width:0; flex-direction:column; align-items:center; justify-content:center; color:#fff; text-align:center; }
.image-question-result-score span { font-size:clamp(13px,3.5vw,25px); font-weight:500; line-height:1.1; white-space:nowrap; }
.image-question-result-score-number { display:flex; align-items:center; justify-content:center; gap:5px; margin-top:3%; }
.image-question-result-score-number img { width:clamp(18px,5vw,36px); height:clamp(18px,5vw,36px); object-fit:contain; }
.image-question-result-score strong { color:#ffcb00; font-size:clamp(25px,7.5vw,54px); font-style:italic; font-weight:900; line-height:.88; text-shadow:0 2px 1px rgba(113,50,0,.45); }
.image-question-result-actions { display:flex; width:100%; align-items:center; justify-content:space-between; gap:4%; margin-top:5%; }
.image-question-result-actions button { position:relative; display:block; width:48%; padding:0; border:0; background:transparent; cursor:pointer; font:inherit; }
.image-question-result-actions img { display:block; width:100%; }
.image-question-result-actions span { position:absolute; top:51%; right:6%; left:6%; transform:translateY(-50%); color:#fff; font-size:clamp(17px,4.7vw,34px); font-weight:900; line-height:1; text-align:center; text-shadow:0 3px 2px rgba(4,3,28,.8); text-transform:uppercase; white-space:nowrap; }
.image-question-result-close { display:block; width:clamp(42px,13vw,96px); margin:3% auto 0; padding:0; border:0; background:transparent; cursor:pointer; }
.image-question-result-close img { display:block; width:100%; }

@keyframes imageQuestionCountdown {
  0% { transform:scale(0); opacity:0; }
  50% { transform:scale(1.2); opacity:1; }
  100% { transform:scale(1); opacity:0; }
}

@media (min-width:760px) {
  .image-question-page-title { margin-bottom:72px; }
  .image-question-card { min-height:940px; }
}
</style>



// WEBPACK FOOTER //
// src/page/ImageQuestion.vue